import { render } from "./Overdue.vue?vue&type=template&id=7d30cd6e&scoped=true"
import script from "./Overdue.vue?vue&type=script&lang=js"
export * from "./Overdue.vue?vue&type=script&lang=js"

import "./Overdue.vue?vue&type=style&index=0&id=7d30cd6e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1198/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d30cd6e"]])

export default __exports__